import { join } from 'light-component';
import { Tag } from 'antd';
import { Box } from '../../../box';
import { Block } from '../../../block';
import { Highlighter } from '../../component';
import styles from '../style.module.less';
import { service } from '../service';
import { RadioBoxComponent } from './radio';
import type { ReactElement } from 'react';
import type { RadioBoxProps } from './types';

export function RadioBoxInputMode(props: RadioBoxProps): ReactElement {
  return (
    <Box className={styles.inputBox} style={{ marginLeft: service.getIndent(props.path, 0.7) }}>
      <Box className={styles.subject}>
        <Block if={props.number != null}>{props.number}、</Block>
        <Block if={props.typeName != null}>
          <Tag color='#ff943f'>{props.typeName}</Tag>
        </Block>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          require={props.validator === 'required'}
          className={styles.title}
        />
      </Box>
      <Box className={join(styles.action, styles.input)}>
        <RadioBoxComponent {...props} />
      </Box>
    </Box>
  );
}
